import { HereResult } from '@user/store/services/hereGeoCoder'
import { useCallback } from 'react'

type Props = {
  map: H.Map | null
}

export function useSetMapView({ map }: Props) {
  const setMapView = useCallback(
    (hereResult: HereResult) => {
      if (map && hereResult) {
        if (
          hereResult.resultType === 'houseNumber' ||
          hereResult.resultType === 'place'
        ) {
          map.setCenter(hereResult.position)
          map.setZoom(17) // A common zoom level for specific addresses
        } else if (hereResult.mapView) {
          // Create a Rect from the bounding box
          const bounds = new H.geo.Rect(
            hereResult.mapView.north,
            hereResult.mapView.west,
            hereResult.mapView.south,
            hereResult.mapView.east,
          )

          // Set the map to show this bounding box
          map.getViewModel().setLookAtData({ bounds })
        }
      }
    },
    [map],
  )

  return { setMapView }
}
